/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response after initializing chunk upload.
 * @export
 * @interface ChunksInitResponse
 */
export interface ChunksInitResponse {
    /**
     * Upload session ID for chunked upload
     * @type {string}
     * @memberof ChunksInitResponse
     */
    uploadId: string;
    /**
     * S3 key/path where chunks should be uploaded
     * @type {string}
     * @memberof ChunksInitResponse
     */
    s3Path: string;
    /**
     * List of presigned URLs for each chunk
     * @type {Array<string>}
     * @memberof ChunksInitResponse
     */
    presignedUrls: Array<string>;
}

/**
 * Check if a given object implements the ChunksInitResponse interface.
 */
export function instanceOfChunksInitResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadId" in value;
    isInstance = isInstance && "s3Path" in value;
    isInstance = isInstance && "presignedUrls" in value;

    return isInstance;
}

export function ChunksInitResponseFromJSON(json: any): ChunksInitResponse {
    return ChunksInitResponseFromJSONTyped(json, false);
}

export function ChunksInitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunksInitResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': json['upload_id'],
        's3Path': json['s3_path'],
        'presignedUrls': json['presigned_urls'],
    };
}

export function ChunksInitResponseToJSON(value?: ChunksInitResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_id': value.uploadId,
        's3_path': value.s3Path,
        'presigned_urls': value.presignedUrls,
    };
}

